import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Avatar from "@mui/material/Avatar";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
import dataUsers3BackgroundImage from "../Media/data-users-3.png";
import { HXButton } from "./HXButton";
import { HXDataGrid } from "./HXDataGrid";
import { HXTextField, multilineEllipsis, srcAttr } from "./base.styles";
import { FlexColumnDiv, FlexRowDiv } from "./common.styles";
import { BoldText, SemiBoldSmallText } from "./HXDesktopPage.styles";
export const SearchArea = styled(FlexRowDiv) `
    gap: 24px;
    align-items: center;
    margin-bottom: 16px;
    align-self: stretch;
    & :nth-child(2) {
        margin-left: auto;
    }
`;
export const Input = styled.div `
    & ${HXTextField} {
        width: 204px;
    }
`;
export const RecruitmentNotStarted = styled.div `
    color: ${colors.chips_slate};
`;
export const RowChevron = styled(ChevronRightIcon) `
    color: ${colors.black_light};
    font-size: 24px !important;
`;
export const ResearcherZeroState = styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
`;
export const ResearcherZeroStateImage = styled.img.attrs(srcAttr(dataUsers3BackgroundImage)) `
    width: 500px;
    display: block;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 20px;
`;
export const ResearcherZeroStateText = styled.div `
    text-align: center;
    margin-bottom: 30px;
`;
export const ResearcherZeroStateCreateNewStudyButton = styled(HXButton) `
    width: 300px;
    justify-content: center;
`;
export const ResearcherZeroStateRelaunchWizardButton = styled(HXButton).attrs({ secondary: true }) `
    width: 300px;
`;
export const StudiesDataGrid = styled(HXDataGrid) `
    & .headerNoWrap .MuiDataGrid-columnHeaderTitle {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
    }
`;
export const AdvancedSearchHeader = styled.div ``;
export const AdvancedSearchTitle = styled.div `
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const StudiesRequiringActionWrapper = styled(FlexColumnDiv) `
    padding: 0 0 24px 0;
    gap: 24px;
`;
export const StudiesRequiringAction = styled(FlexColumnDiv) `
    padding: 24px;
    gap: 8px;

    border-radius: 4px;
    border: 1px solid ${colors.sunset_main};
    background: ${colors.sunset_8};
`;
export const StudiesRequiringActionHeader = styled(FlexRowDiv) `
    justify-content: space-between;
`;
export const StudiesSectionTitle = styled.div `
    color: ${colors.black_main};
    font-size: ${fontSizes.MEDIUM};
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const StudiesRequiringActionList = styled(FlexRowDiv) `
    gap: 24px;
    flex-wrap: wrap;
`;
export const StudiesRequiringActionCard = styled(FlexColumnDiv) `
    height: 201px;
    padding: 24px;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    border-radius: 4px;
    border: 1px solid ${colors.navy_12};
    background: ${colors.white_main};
    flex: 0 0 calc(33.33% - 16px); // 16 = 2 * 24 / 3 = 2 gaps * 24px padding / 3 items
`;
export const CardTop = styled(FlexColumnDiv) `
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
`;
export const CardBadge = styled.div `
    background-color: ${colors.accents_sunset};
    color: white;
    text-transform: uppercase;
    padding: 0 7px;
    border-radius: 100px;
    font-size: ${fontSizes.TINY};
`;
export const CardTitle = styled(BoldText) `
    ${multilineEllipsis(2)}
`;
export const CardOtherInfo = styled(FlexColumnDiv) `
    gap: 4px;
`;
export const CircularOrgLogo = styled(Avatar) `
    width: 24px;
    height: 24px;
    border: 1px solid ${colors.black_12};
    align-self: flex-start;
`;
export const CardBottom = styled(FlexColumnDiv) `
    align-self: stretch;
    align-items: stretch;
    gap: 8px;
`;
export const SearchAreaAndTitle = styled(FlexColumnDiv) `
    gap: 16px;
`;
export const SponsorName = styled.div `
    ${multilineEllipsis(2)}
`;
export const SponsorNameAndLogo = styled(FlexRowDiv) `
    gap: 8px;
    align-items: center;
`;
export const LastActivityContainer = styled(FlexRowDiv) `
    gap: 8px;
    align-items: center;
`;
export const ProjectTitle = styled(SemiBoldSmallText) `
    ${multilineEllipsis(1)}
`;
